const textReplacer = (
  copy: string,
  replacements: { [key: string]: any }
) => {
  if (!copy) {
    return new Error('The copy is undefined. Please check your translations.')
  }

  let str: string = copy;

  for (const key in replacements) {
    str = str.replace(key, replacements[key]);
  }

  return str;
};

export default textReplacer